import { css } from '@spectrum-web-components/base';
const styles = css`
    #tooltip{--spectrum-tooltip-backgound-color-default-neutral:var(--system-tooltip-backgound-color-default-neutral)}
`;
export default styles;